import { useEffect } from 'react';
import { useAppContext } from "./context/AppContext";
import LegalFooter from './layout/LegalFooter'
import Module from './layout/Module'
import Navigation from './components/Navigation'
import pageData from './data/data'

import "./style.scss";

const MOBILE_BREAKPOINT = 992;

function App() {
    const { breakpoint, updateBreakpoint, mobileMenuIsOpen, toggleMobileMenu, viewportWidth } = useAppContext();

    useEffect(() => {
        updateBreakpoint( MOBILE_BREAKPOINT );
        if (( viewportWidth >= breakpoint ) && ( mobileMenuIsOpen !== false )) {
            toggleMobileMenu()
        }
    })

    return (
        <>
            <div className="postiva-container">
                <Navigation />
                <Module pageData={pageData} />
            </div>
            <LegalFooter />
        </>
    );
}

export default App;
